import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Alert,
    Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function DeleteDialog({
                                         open,
                                         title,
                                         message,
                                         loading = false,
                                         onClose,
                                         onConfirm
                                     }) {
    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Box display="flex" gap={1}>
                    {title}
                </Box>
            </DialogTitle>

            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>
                    {message}
                </DialogContentText>

                <Alert
                    severity="warning"
                    sx={{ py: 0.25 }}
                >
                    <b>Warning!</b> Deleting this item is permanent and cannot be undone.
                </Alert>
            </DialogContent>

            <DialogActions sx={{ pt: 0 }}>
                <Button
                    disabled={loading}
                    onClick={onClose}
                >
                    Cancel
                </Button>

                <Button
                    color="error"
                    variant="contained"
                    startIcon={<DeleteIcon />}
                    loading={loading}
                    onClick={onConfirm}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}